import { render, staticRenderFns } from "./SolicitacoesDocumentos.vue?vue&type=template&id=f820270c&scoped=true&"
import script from "./SolicitacoesDocumentos.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacoesDocumentos.vue?vue&type=style&index=0&id=f820270c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f820270c",
  null
  
)

export default component.exports